import React, { FC } from 'react'

import { Typography, useTheme } from '@mui/material'
import Box from '@mui/material/Box'
import { addMonths, format, isBefore, startOfMonth, subMonths } from 'date-fns'
import { de, enUS, es, fr, it, uk } from 'date-fns/locale'
import { useTranslation } from 'react-i18next'

import { CustomButton } from '../../../components/CustomButton'
import { ChevronButton } from '../../../components/ShevronButton'
import { Direction } from '../../../types'

import { HeaderProps } from './type'

export const CalendarHeader: FC<HeaderProps> = ({ currentDate, setCurrentDate }) => {
  const { spacing } = useTheme()
  const { t, i18n } = useTranslation()
  const language = (i18n.resolvedLanguage || i18n.language || 'en').split('-')[0]
  const dateLocale = { en: enUS, uk, es, fr, it, de }[language] || enUS
  const monthYear = format(currentDate, 'LLLL yyyy', { locale: dateLocale })
  const localizedMonthYear = monthYear.charAt(0).toUpperCase() + monthYear.slice(1)
  const canGoNext = isBefore(startOfMonth(currentDate), startOfMonth(new Date()))

  const handleTodayClick = () => {
    setCurrentDate(new Date())
  }

  const handlePrevClick = () => {
    const prevMonth = subMonths(currentDate, 1)
    setCurrentDate(prevMonth)
  }

  const handleNextClick = () => {
    if (canGoNext) {
      setCurrentDate(addMonths(currentDate, 1))
    }
  }

  return (
    <Box display="flex" justifyContent="space-between" alignItems="center">
      <CustomButton
        color="secondary"
        sx={{ height: spacing(4) }}
        onClick={handleTodayClick}
        className="period-calendar"
      >
        {t('today', 'Today')}
      </CustomButton>
      <Typography variant="h5" fontSize={{ xs: 14, sm: 18 }}>
        {localizedMonthYear}
      </Typography>
      <Box display="flex" gap={spacing(1)}>
        <ChevronButton onClick={handlePrevClick} direction={Direction.left} />
        <ChevronButton onClick={handleNextClick} disabled={!canGoNext} />
      </Box>
    </Box>
  )
}
